import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';

@Component({
  templateUrl: 'account-created.component.html'
})
export class AccountCreatedComponent implements OnInit {

  public email: string;

  constructor(private route: ActivatedRoute
  ) {

  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: Params) => {
      this.email = params['email'];
    });

  }






}
